var toggleWoff2Font = true;

var fontType = (function () {
    var supportsWoff2 = (function (win) {
        if (!("FontFace" in win)) return false;
        var f = new win.FontFace('t', 'url(data:application/font-woff2;charset=utf-8;base64,) format("woff2")', {});
        f.load().catch(function () { });
        return f.status == 'loading';
    })(this);

    function requiresTTF() {
        return navigator.userAgent.toLowerCase().match(/android|vita|playstation/g) !== null;
    }

    if (supportsWoff2) {
        return ".woff2";
    }
    else if (requiresTTF()) {
        return ".ttf";
    }
    else {
        return ".woff";
    }

})();

function getURLParameterbyName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


function loadFont(fontFamily, url) {
    var font = new FontFace(fontFamily, "url('" + url + fontType + "')");
    font.load();
    document.fonts.add(font);
}

var str = ["%3Clink rel='stylesheet' href='https://fonts.sony.net/shf/v31/latinextended/base.css'%3E"];
str.push("%3Clink rel='stylesheet' href='" + 'https://fonts.sony.net/shf/icons/system/v17/Sony-System-Icons.css' + "'%3E");
document.write(decodeURIComponent(str.join('')));
document.write(unescape("%3Cmeta class='deferred-css' data-href='https://fonts.sony.net/shf/v31/latinextended/extra.css'%3E"));

var gwtheader;
var gwtfooter;
var responsive = true;

var respheader = "";
var nonrespheader = "";
var respfooter = "";
var nonrespfooter = "";

// respheader = `${domain}/app/shared/header?includeFontType=false&includeCss=true&includeJs=true&type=responsive&locale=${locale}&account_session_link=https://test.sony.co.th/mysony/th/displayname&account_signin_url=https://test.sony.co.th/mysony/th/loginredirect?returnUri=${window.theme.shopUrl}&account_signout_url=https://test.sony.co.th/mysony/th/logoutredirect`;
respheader = domain +'/app/shared/header?includeFontType=false&includeCss=true&includeJs=true&type=responsive&locale=' + locale;

respfooter = domain + '/app/shared/footer?includeFontType=false&includeCss=true&includeJs=true&type=responsive&locale=' + locale;
 


jQuery(document).ready(function () {
    $("tbody").attr("style", "overflow-x: hidden");
    $("form").attr("style", "margin-bottom: 0");

    // GWT SHF
    jQuery('meta').each(function () {
        if (jQuery(this).attr('name') == 'viewport') {
            responsive = true;
        }
    });
    if (responsive == true) {
        gwtheader = respheader;
        gwtfooter = respfooter;
    } else {
        gwtheader = nonrespheader;
        gwtfooter = nonrespfooter;
    }

    /* Code commented by Hitach */
    //jQuery('.sony_header_container').load(gwtheader);
    //jQuery('.sony_footer_container').load(gwtfooter);


    jQuery('.HeaderFullBleed').load(gwtheader, function () {
        setTimeout(function () {
            setupRedirectionLinks();
            handleContinueShoppingCTA();
        }, 1500);

        jQuery('.FooterFullBleed').load(gwtfooter, function () {
            setTimeout(function () {
                //alert("Boom!");
                $('.HeaderFullBleed').removeClass('hide');
                $('.FooterFullBleed').removeClass('hide');
                $('#page-main-content').removeClass('hide');
                $('#custom_contactUsContent').removeClass('hide');
                $('.container-fluid').removeClass('hide');
            }, 250);
        });
    });
});

function setupRedirectionLinks() {
  const menuTriggerElm = $('.MegaHeader_mySony');

  if (menuTriggerElm.length) {
    menuTriggerElm.on('click.setup-links', function() {
      if (menuTriggerElm.hasClass('-isActive')) {
        const isLoggedIn = window.theme.isLoggedIn;
        const language = window.theme.locale;
        
        const redirectUrl = language === 'en' ? window.theme.shopUrl : `${window.theme.shopUrl}/${language}`;
        const redirectionItems = [
          {
            selector: '.MySony_Links a[href*="my-account/orders"]',
            loggedInHref: `${redirectUrl}/account`,
            href: `https://test.sony.co.th/${language}/mysony/th/login?returnUri=${redirectUrl}`
          },
          {
            selector: '.MySony_Links a[href*="my-account/address-book"]',
            loggedInHref: `${redirectUrl}/account/addresses`,
            href: `https://test.sony.co.th/${language}/mysony/th/login?returnUri=${redirectUrl}`
          }
        ];

        redirectionItems.forEach(({selector, loggedInHref, href}) => {
          const itemHref = isLoggedIn ? loggedInHref : href;
          $(selector).attr('href', itemHref);
        });
      }
    })
  }
}

function handleContinueShoppingCTA() {
  const continueShoppingButtonElm = $('.button--continue-shoping');

  if (continueShoppingButtonElm.length) {
    continueShoppingButtonElm.on('click', function(evt) {
      evt.preventDefault();
      const url = document.referrer || '/';
      window.location.href = url;
    });
  }
}
